// Components, Layouts, Pages
import {
  CrmCommonPage,
  JobsCommonPage,
  LeadCommonPage,
  TaskCommonPage,
  UserCommonPage,
  VenueCommonPage,
  OrderCommonPage,
  QuotesCommonPage,
  TrucksCommonPage,
  ClientCommonPage,
  GlobalCommonPage,
  ReportsCommonPage,
  TrailerCommonPage,
  PackageCommonPage,
  InvoiceCommonPage,
  VendorsCommonPage,
  CouponsCommonPage,
  ScheduleCommonPage,
  SettingsCommonPage,
  CategoryCommonPage,
  UserFormCommonPage,
  VehiclesCommonPage,
  DashboardCommonPage,
  EquipmentCommonPage,
  InventoryCommonPage,
  EventTypeCommonPage,
  RoleFormCommonPage,
  VenueFormCommonPage,
  OrderFormCommonPage,
  ChecklistCommonPage,
  JobDetailCommonPage,
  QuarantineCommonPage,
  QuotesFormCommonPage,
  UserDetailCommonPage,
  ClientFormCommonPage,
  InventoriesCommonPage,
  PackageFormCommonPage,
  VenueDetailCommonPage,
  InvoiceFormCommonPage,
  ClientDetailCommonPage,
  QuotesDetailCommonPage,
  OrderDetailsCommonPage,
  PurchaseOrderCommonPage,
  InventoryFormCommonPage,
  RevenueReportCommonPage,
  DeliveryReportCommonPage,
  TaskCompletionCommonPage,
  VendorsDetailsCommonPage,
  RoleManagementCommonPage,
  InventoryDetailCommonPage,
  JobCostingReportCommonPage,
  QuarantineReportCommonPage,
  QuoteRevenueReportCommonPage,
  OrderRevenueReportCommonPage,
  CancellationReportCommonPage,
  ClientIncomeReportCommonPage,
  FeatureUtilizationCommonPage,
  ReportsForemanTaskCommonPage,
  DiscountUsageReportCommonPage,
  PurchaseOrderDetailsCommonPage,
  ReportsFinancialOrderCommonPage,
  ReportsInventoryUsageCommonPage,
  ReportsOverbookingItemCommonPage,
  ReportsMarketingRevenueCommonPage,
  GeographicRevenueReportCommonPage,
  ReportsSubrentalsReportCommonPage,
  ReportsTransactionSummaryCommonPage,
} from '~/pages/common';
// Others
import { MenuNameEnum } from '~/utils/enum/common';
import { IRouteModel } from '~/utils/interface/base';
import { operationsManagerRoute, operationsManagerRouteAbsolute } from '../roleRoutes/operationsManager';
// Styles, images, icons
import { icons } from '~/assets';

export const privateOperationsManagerRoutes: IRouteModel[] = [
  // Dashboard
  {
    index: true,
    path: operationsManagerRoute.base,
    component: DashboardCommonPage,
    name: MenuNameEnum.DASHBOARD,
    icon: icons.menuIconDashboardUnactive,
    activeIcon: icons.menuIconDashboardActive,
  },

  // Global
  {
    path: operationsManagerRouteAbsolute.global,
    component: GlobalCommonPage,
  },

  // CRM
  {
    path: operationsManagerRouteAbsolute.crm,
    component: CrmCommonPage,
    name: MenuNameEnum.CRM,
    icon: icons.menuIconCrmUnactive,
    activeIcon: icons.menuIconCrmActive,
    children: [
      {
        path: operationsManagerRouteAbsolute.leads,
        component: LeadCommonPage,
        name: MenuNameEnum.LEADS,
      },
      {
        path: operationsManagerRouteAbsolute.clients,
        component: ClientCommonPage,
        name: MenuNameEnum.CLIENT,
      },
    ],
  },
  {
    path: operationsManagerRouteAbsolute.createLead,
    component: ClientFormCommonPage,
  },
  {
    path: `${operationsManagerRoute.base}${operationsManagerRoute.crm}${operationsManagerRoute.leads}${operationsManagerRoute.commonDetail}${operationsManagerRoute.commonEdit}`,
    component: ClientFormCommonPage,
  },
  {
    path: `${operationsManagerRoute.base}${operationsManagerRoute.crm}${operationsManagerRoute.leads}${operationsManagerRoute.commonDetail}`,
    component: ClientDetailCommonPage,
  },
  {
    path: operationsManagerRouteAbsolute.createClient,
    component: ClientFormCommonPage,
  },
  {
    path: `${operationsManagerRoute.base}${operationsManagerRoute.crm}${operationsManagerRoute.clients}${operationsManagerRoute.commonDetail}${operationsManagerRoute.commonEdit}`,
    component: ClientFormCommonPage,
  },
  {
    path: `${operationsManagerRoute.base}${operationsManagerRoute.crm}${operationsManagerRoute.clients}${operationsManagerRoute.commonDetail}`,
    component: ClientDetailCommonPage,
  },

  // Schedule
  {
    path: operationsManagerRouteAbsolute.schedule,
    component: ScheduleCommonPage,
    name: MenuNameEnum.SCHEDULE,
    icon: icons.menuIconScheduleUnactive,
    activeIcon: icons.menuIconScheduleActive,
  },

  // Jobs
  {
    path: operationsManagerRouteAbsolute.jobs,
    component: JobsCommonPage,
    name: MenuNameEnum.JOBS,
    icon: icons.menuIconJobsUnactive,
    activeIcon: icons.menuIconJobsActive,
  },
  {
    path: `${operationsManagerRoute.base}${operationsManagerRoute.jobs}${operationsManagerRoute.commonDetail}`,
    component: JobDetailCommonPage,
  },

  // Task
  {
    path: operationsManagerRouteAbsolute.task,
    name: MenuNameEnum.TASKS,
    icon: icons.menuIconTaskInActive,
    activeIcon: icons.menuIconTaskActive,
    component: TaskCommonPage,
  },

  // Communication
  // {
  //   path: operationsManagerRouteAbsolute.communication,
  //   component: CommunicationCommonPage,
  //   name: MenuNameEnum.COMMUNICATION,
  //   icon: icons.menuIconCommunicationUnactive,
  //   activeIcon: icons.menuIconCommunicationActive,
  // },

  // Quotes
  {
    path: operationsManagerRouteAbsolute.quotes,
    component: QuotesCommonPage,
    name: MenuNameEnum.QUOTES,
    icon: icons.menuIconQuotesUnactive,
    activeIcon: icons.menuIconQuotesActive,
  },
  {
    path: operationsManagerRouteAbsolute.createQuotes,
    component: QuotesFormCommonPage,
  },
  {
    path: `${operationsManagerRoute.base}${operationsManagerRoute.quotes}${operationsManagerRoute.commonDetail}${operationsManagerRoute.commonEdit}`,
    component: QuotesFormCommonPage,
  },

  //  Order
  {
    path: operationsManagerRouteAbsolute.order,
    component: OrderCommonPage,
    name: MenuNameEnum.ORDER,
    icon: icons.menuIconOrderInactive,
    activeIcon: icons.menuIconOrderActive,
  },
  {
    path: `${operationsManagerRoute.base}${operationsManagerRoute.order}${operationsManagerRoute.commonDetail}`,
    component: OrderDetailsCommonPage,
  },
  {
    path: `${operationsManagerRoute.base}${operationsManagerRoute.order}${operationsManagerRoute.commonDetail}${operationsManagerRoute.commonEdit}`,
    component: OrderFormCommonPage,
  },

  // Invoice
  {
    path: operationsManagerRouteAbsolute.invoices,
    component: InvoiceCommonPage,
    name: MenuNameEnum.INVOICE,
    icon: icons.menuIconInvoiceInactive,
    activeIcon: icons.menuIconInvoiceActive,
  },
  {
    path: operationsManagerRouteAbsolute.createInvoice,
    component: InvoiceFormCommonPage,
  },
  {
    path: `${operationsManagerRoute.base}${operationsManagerRoute.invoice}${operationsManagerRoute.commonDetail}${operationsManagerRoute.commonEdit}`,
    component: InvoiceFormCommonPage,
  },

  // Inventories
  {
    path: `${operationsManagerRoute.base}${operationsManagerRoute.quotes}${operationsManagerRoute.commonDetail}`,
    component: QuotesDetailCommonPage,
  },
  {
    path: operationsManagerRouteAbsolute.inventories,
    component: InventoriesCommonPage,
    name: MenuNameEnum.INVENTORY,
    icon: icons.menuIconInventoryInactive,
    activeIcon: icons.menuIconInventoryActive,
    children: [
      {
        path: operationsManagerRouteAbsolute.inventory,
        component: InventoryCommonPage,
        name: MenuNameEnum.PRODUCT,
      },
      {
        path: operationsManagerRouteAbsolute.package,
        component: PackageCommonPage,
        name: MenuNameEnum.PACKAGE,
      },
      {
        path: operationsManagerRouteAbsolute.quarantine,
        component: QuarantineCommonPage,
        name: MenuNameEnum.QUARANTINE,
      },
    ],
  },
  {
    path: operationsManagerRouteAbsolute.createInventory,
    component: InventoryFormCommonPage,
  },
  {
    path: `${operationsManagerRoute.base}${operationsManagerRoute.inventory}${operationsManagerRoute.product}${operationsManagerRoute.commonDetail}`,
    component: InventoryDetailCommonPage,
  },
  {
    path: `${operationsManagerRoute.base}${operationsManagerRoute.inventory}${operationsManagerRoute.product}${operationsManagerRoute.commonDetail}${operationsManagerRoute.commonEdit}`,
    component: InventoryFormCommonPage,
  },
  {
    path: `${operationsManagerRoute.base}${operationsManagerRoute.inventory}${operationsManagerRoute.package}${operationsManagerRoute.commonDetail}${operationsManagerRoute.commonEdit}`,
    component: PackageFormCommonPage,
  },
  {
    path: `${operationsManagerRoute.base}${operationsManagerRoute.inventory}${operationsManagerRoute.package}${operationsManagerRoute.commonDetail}${operationsManagerRoute.commonClone}`,
    component: PackageFormCommonPage,
  },

  // Report
  {
    path: `${operationsManagerRoute.base}${operationsManagerRoute.reports}`,
    component: ReportsCommonPage,
    name: MenuNameEnum.REPORTS,
    icon: icons.menuIconReportUnactive,
    activeIcon: icons.menuIconReportActive,
  },
  {
    path: `${operationsManagerRoute.base}${operationsManagerRoute.reports}${operationsManagerRoute.overbookingItem}`,
    component: ReportsOverbookingItemCommonPage,
  },
  {
    path: `${operationsManagerRoute.base}${operationsManagerRoute.reports}${operationsManagerRoute.subrentalsReport}`,
    component: ReportsSubrentalsReportCommonPage,
  },
  {
    path: `${operationsManagerRoute.base}${operationsManagerRoute.reports}${operationsManagerRoute.clientIncomeReport}`,
    component: ClientIncomeReportCommonPage,
  },
  {
    path: `${operationsManagerRoute.base}${operationsManagerRoute.reports}${operationsManagerRoute.revenueReport}`,
    component: RevenueReportCommonPage,
  },
  {
    path: `${operationsManagerRoute.base}${operationsManagerRoute.reports}${operationsManagerRoute.geographicRevenueReport}`,
    component: GeographicRevenueReportCommonPage,
  },
  {
    path: `${operationsManagerRoute.base}${operationsManagerRoute.reports}${operationsManagerRoute.quoteRevenueReport}`,
    component: QuoteRevenueReportCommonPage,
  },
  {
    path: `${operationsManagerRoute.base}${operationsManagerRoute.reports}${operationsManagerRoute.orderRevenueReport}`,
    component: OrderRevenueReportCommonPage,
  },
  {
    path: `${operationsManagerRoute.base}${operationsManagerRoute.reports}${operationsManagerRoute.cancellationReport}`,
    component: CancellationReportCommonPage,
  },
  {
    path: `${operationsManagerRoute.base}${operationsManagerRoute.reports}${operationsManagerRoute.deliveryReport}`,
    component: DeliveryReportCommonPage,
  },
  {
    path: `${operationsManagerRoute.base}${operationsManagerRoute.reports}${operationsManagerRoute.taskCompletionReport}`,
    component: TaskCompletionCommonPage,
  },
  {
    path: `${operationsManagerRoute.base}${operationsManagerRoute.reports}${operationsManagerRoute.discountUsageReport}`,
    component: DiscountUsageReportCommonPage,
  },
  {
    path: `${operationsManagerRoute.base}${operationsManagerRoute.reports}${operationsManagerRoute.featureUtilizationReport}`,
    component: FeatureUtilizationCommonPage,
  },
  {
    path: `${operationsManagerRoute.base}${operationsManagerRoute.reports}${operationsManagerRoute.jobCostingReport}`,
    component: JobCostingReportCommonPage,
  },
  {
    path: `${operationsManagerRoute.base}${operationsManagerRoute.reports}${operationsManagerRoute.inventoryUsageReport}`,
    component: ReportsInventoryUsageCommonPage,
  },
  {
    path: `${operationsManagerRoute.base}${operationsManagerRoute.reports}${operationsManagerRoute.quarantineReport}`,
    component: QuarantineReportCommonPage,
  },
  {
    path: `${operationsManagerRoute.base}${operationsManagerRoute.reports}${operationsManagerRoute.foremanTaskReport}`,
    component: ReportsForemanTaskCommonPage,
  },
  {
    path: `${operationsManagerRoute.base}${operationsManagerRoute.reports}${operationsManagerRoute.marketingRevenueReport}`,
    component: ReportsMarketingRevenueCommonPage,
  },
  {
    path: `${operationsManagerRoute.base}${operationsManagerRoute.reports}${operationsManagerRoute.financialOrderReport}`,
    component: ReportsFinancialOrderCommonPage,
  },
  {
    path: `${operationsManagerRoute.base}${operationsManagerRoute.reports}${operationsManagerRoute.transactionSummaryReport}`,
    component: ReportsTransactionSummaryCommonPage,
  },

  // Package
  {
    path: operationsManagerRouteAbsolute.createPackage,
    component: PackageFormCommonPage,
  },

  {
    path: operationsManagerRouteAbsolute.vehicles,
    component: VehiclesCommonPage,
    name: MenuNameEnum.VEHICLES,
    icon: icons.menuIconVehicleInactive,
    activeIcon: icons.menuIconVehicleActive,
    children: [
      {
        path: operationsManagerRouteAbsolute.trucks,
        component: TrucksCommonPage,
        name: MenuNameEnum.TRUCKS,
        icon: icons.menuIconTruckInActive,
        activeIcon: icons.menuIconTruckActive,
      },
      {
        path: operationsManagerRouteAbsolute.trailers,
        component: TrailerCommonPage,
        name: MenuNameEnum.TRAILERS,
        icon: icons.menuIconTrailerInActive,
        activeIcon: icons.menuIconTrailerActive,
      },
      {
        path: operationsManagerRouteAbsolute.equipments,
        component: EquipmentCommonPage,
        name: MenuNameEnum.EQUIPMENTS,
        icon: icons.menuIconEquipmentInActive,
        activeIcon: icons.menuIconEquipmentActive,
      },
    ],
  },

  // Vendors
  {
    path: operationsManagerRouteAbsolute.vendors,
    component: VendorsCommonPage,
    name: MenuNameEnum.VENDORS,
    icon: icons.menuIconVendorsInactive,
    activeIcon: icons.menuIconVendorsActive,
  },
  {
    path: operationsManagerRouteAbsolute.detailVendor,
    component: VendorsDetailsCommonPage,
  },

  // Purchase Order
  {
    path: operationsManagerRouteAbsolute.purchaseOrder,
    component: PurchaseOrderCommonPage,
    name: MenuNameEnum.PURCHASE_ORDER,
    icon: icons.menuIconPurchaseInactive,
    activeIcon: icons.menuIconPurchaseActive,
  },
  {
    path: `${operationsManagerRoute.base}${operationsManagerRoute.purchaseOrder}${operationsManagerRoute.commonDetail}`,
    component: PurchaseOrderDetailsCommonPage,
  },

  // Settings
  {
    path: operationsManagerRouteAbsolute.settings,
    component: SettingsCommonPage,
    name: MenuNameEnum.SETTINGS,
    icon: icons.menuIconSettingUnactive,
    activeIcon: icons.menuIconSettingActive,
  },

  // User
  {
    path: operationsManagerRouteAbsolute.users,
    component: UserCommonPage,
  },
  {
    path: `${operationsManagerRoute.base}${operationsManagerRoute.settings}${operationsManagerRoute.users}${operationsManagerRoute.commonDetail}`,
    component: UserDetailCommonPage,
  },
  {
    path: operationsManagerRouteAbsolute.createUser,
    component: UserFormCommonPage,
  },
  {
    path: `${operationsManagerRoute.base}${operationsManagerRoute.settings}${operationsManagerRoute.users}${operationsManagerRoute.commonDetail}${operationsManagerRoute.commonEdit}`,
    component: UserFormCommonPage,
  },

  // Venue
  {
    path: operationsManagerRouteAbsolute.venue,
    component: VenueCommonPage,
  },
  {
    path: `${operationsManagerRoute.base}${operationsManagerRoute.settings}${operationsManagerRoute.venue}${operationsManagerRoute.commonDetail}`,
    component: VenueDetailCommonPage,
  },
  {
    path: operationsManagerRouteAbsolute.createVenue,
    component: VenueFormCommonPage,
  },
  {
    path: `${operationsManagerRoute.base}${operationsManagerRoute.settings}${operationsManagerRoute.venue}${operationsManagerRoute.commonDetail}${operationsManagerRoute.commonEdit}`,
    component: VenueFormCommonPage,
  },

  // Role Management
  {
    path: operationsManagerRouteAbsolute.roleManagement,
    component: RoleManagementCommonPage,
  },
  {
    path: operationsManagerRouteAbsolute.createRole,
    component: RoleFormCommonPage,
  },
  {
    path: `${operationsManagerRoute.base}${operationsManagerRoute.settings}${operationsManagerRoute.roleManagement}${operationsManagerRoute.commonDetail}${operationsManagerRoute.commonEdit}`,
    component: RoleFormCommonPage,
  },

  // Coupon
  {
    path: operationsManagerRouteAbsolute.coupon,
    component: CouponsCommonPage,
  },

  // Event Type
  {
    path: operationsManagerRouteAbsolute.eventType,
    component: EventTypeCommonPage,
  },

  // Category
  {
    path: operationsManagerRouteAbsolute.category,
    component: CategoryCommonPage,
  },

  // Checklist
  {
    path: operationsManagerRouteAbsolute.checklist,
    component: ChecklistCommonPage,
  },
];
